export const rpcPermissions =
  JSON.parse(atob(window._env_?.RPC_PERMISSIONS_OPTIONS || import.meta.env.VITE_RPC_PERMISSIONS_OPTIONS)) || {};
